<template>
    <v-card class="py-1 px-4 elevation-0">
        <v-dialog v-model="warning" class="red--text" width="200">
            <v-card light>
                <v-card-title class="red darken-2 white--text">Image too large</v-card-title>
                <v-btn color="red darken-1" flat @click.native="warning=false">OK</v-btn>
            </v-card>
        </v-dialog>

        <v-card-title class="pa-0"></v-card-title>
        <v-card-text v-if="!editMode">
            <img class="icon btn--round elevation-3 center-cropped-50 left mt-2 mr-1"
                 :src="$helper.getLocation() + activeUser.img">
            <v-text-field class="flex md11 offset-md1 xs12 grey--text-field" :multiLine="true" :rows="rowsMultiline"
                          @click="setEditMode()" title="Post News"></v-text-field>
        </v-card-text>
        <v-form v-else="" v-model="valid">
            <v-layout row wrap>
                <v-flex xs12 sm6 offset-sm3 color="red" class="red--text">
                    <v-text-field label="Title" v-model="news.headline"
                                  :rules="notEmpty"
                                  required></v-text-field>
                </v-flex>
                <v-flex xs12 color="red" class="red--text text-xs-center">
                    <croppa
                            v-model="myCroppa"
                            canvas-color="white"
                            :file-size-limit="1500000"
                            @file-size-exceed="warning=true"
                            :width="img.width" :height="img.height" :quality="2" :remove-button-size="0"
                            @file-choose="file => uploadImg(file)"></croppa>
                </v-flex>

                <v-flex xs12 color="red" class="red--text">
                    <v-layout row>
                        <v-flex v-if="implemented" xs12 md2>
                            <v-select
                                    label="type"
                                    :rules="notEmpty"
                                    v-model="news.media_type"
                                    :items="['img', 'gif', 'video']"
                            ></v-select>
                        </v-flex>
                    </v-layout>

                </v-flex>

                <v-flex xs12 pa-2 grey>
                    <v-text-field multiLine class="elevation-3 white pl-3 pr-3" color="indigo" :rows="2"
                                  label="Summary" v-model="news.short_text"
                                  :rules="notEmpty"
                                  :counter="255"
                                  required></v-text-field>
                </v-flex>
                <v-flex xs12 pa-2 grey>
                    <v-text-field multiLine class="elevation-3 white pl-3 pr-3" color="indigo" :rows="4"
                                  label="Langer Text" v-model="news.long_text"
                                  :rules="notEmpty"
                                  :counter="255"
                                  required></v-text-field>
                    <!--          <wysiwyg class="elevation-3 white darken-3" v-model="news.long_text" :rules="notEmpty"
                                       placeholder="Training Inhalt - lange Beschreibung"></wysiwyg>-->
                    <!--   <v-text-field multiLine class="elevation-3 white pl-3 pr-3" color="indigo"
                                     label="Text" v-model="news.long_text"
                                     :rules="notEmpty"
                                     :counter="2000"
                                     required></v-text-field>-->
                </v-flex>
            </v-layout>
        </v-form>
        <v-card-text v-if="editMode">
            <small>*indicates required field</small>
            <br>
            <small v-if="!valid" class="red--text darken-2 pa-1">
                <v-icon color="red">error</v-icon>
                Please fill out all fields
            </small>
        </v-card-text>
        <v-card-actions v-if="editMode" class="affix fixed-card-actions">
            <v-spacer></v-spacer>
            <v-btn color="grey darken-3" flat @click.native="editMode=false">Cancel</v-btn>
            <v-btn color="blue darken-3 elevation-5" class="elevation-5 grey lighten-3" flat
                   @click="submit()"
                   :disabled="!valid">Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'news-dialog',
        props: ['activeUser'],
        data() {
            return {
                rowsMultiline: 1,
                notEmpty: [
                    (v) => !!v || 'Field is required.',
                ],
                valid: false,
                editMode: false,
                implemented: false,
                myCroppa: {},
                warning: false,
                img: {
                    width: 600,
                    height: 400
                }, fileName: '', factor: 1,
                news: {
                    user_id: this.activeUser.id,
                    short_text: '',
                    long_text: '',
                    imgFile: '',
                    path: '.',
                    fileName: '',
                    media_type: 'img',
                    headline: '',
                    text: '',
                    type: 'news',
                    id: '',
                    comments: '',
                    likes: '',
                    likes_favorite: '',
                },
            };
        },
        methods: {
            ...mapActions(['getAllNews', 'updatePoints']),
            uploadImg(file) {
                let fileReader = new FileReader()
                this.factor = 200000 / file.size > 1 ? 1 : 200000 / file.size
                this.news.fileName = file.name
                fileReader.readAsDataURL(file)
            },
            imageChanged(file, cb) {
                const reader = new FileReader()
                this.myCroppa.generateBlob(
                    blob => {
                        reader.readAsDataURL(blob)
                        reader.onload = (e) => {
                            this.news.imgFile = e.target.result
                            cb()
                            this.myCroppa.refresh()
                        }
                    },
                    'image/jpeg',
                    0.8
                )
            },
            setEditMode() {
                this.editMode = true
                if (window.innerWidth < this.img.width + 80) {
                    this.img.width = window.innerWidth - 80
                    this.img.height = (window.innerWidth - 50) * .75
                }
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'editNews',
                    eventAction: 'edit',
                    eventLabel: "Edit",
                    eventValue: 100
                });
            },
            submit() {
                this.imageChanged(false, () => {
                    this.news.updated_at = this.$helper.getTimeStamp();
                    this.news.created_at = this.$helper.getTimeStamp();
                    this.$http.post(this.$helper.apiUrl() + '/content/news', this.news).then(
                        (resp) => {
                            if (this.news.imgFile) {
                                let media = {
                                    path: this.news.fileName.length > 0 ? '/img/news/' + this.news.fileName : '.',
                                    media_type: this.news.media_type,
                                    updated_at: this.$helper.getTimeStamp(),
                                    created_at: this.$helper.getTimeStamp(),
                                    ref_id: resp.body,
                                    type: 'news',
                                };
                                this.$http.post(this.$helper.apiUrl() + '/media', media).then(
                                    () => {
                                        this.getAllNews();
                                        this.updatePoints({user_id: this.activeUser.id, points: 10})
                                    },
                                );
                            } else {
                                this.getAllNews();
                                this.updatePoints({user_id: this.activeUser.id, points: 10})
                            }
                            this.editMode = false;
                            this.news = {
                                user_id: this.activeUser.id,
                                short_text: '',
                                long_text: '',
                                imgFile: '',
                                path: '.',
                                fileName: '',
                                media_type: 'img',
                                headline: '',
                                text: '',
                                type: 'news',
                                id: '',
                                comments: '',
                                likes: '',
                                likes_favorite: '',
                            };
                            ga('send', {
                                hitType: 'event',
                                eventCategory: 'addNewsItem',
                                eventAction: 'edit',
                                eventLabel: "Edit",
                                eventValue: 400
                            });
                        });
                })
            },
            deleteNews(newsId) {
                this.$http.delete(this.$helper.apiUrl() + '/content/news/' + newsId).then(
                    () => {
                        this.getAllNews();
                        this.getAllMedia();
                    });
            },
            addNews() {
                this.editMode = false;
                this.news = {
                    imgFile: '',
                    user_id: this.$store.state.users.active.id,
                    fileName: '',
                    media_type: 'img',
                    headline: 'Headline',
                    text: '',
                    type: 'news',
                    id: '',
                };
            },
            updateNews() {
                this.news.updated_at = getTimeStamp()
                this.$http.put(this.$helper.apiUrl() + '/content/news/' + this.news.id, this.news).then(
                    (resp) => {
                        let media = {
                            path: '/img/news/' + this.news.fileName,
                            media_type: this.news.media_type,
                            updated_at: this.$helper.getTimeStamp(),
                            created_at: this.$helper.getTimeStamp(),
                            ref_id: resp.body,
                            type: 'news',
                        };
                        this.$http.post(this.$helper.apiUrl() + '/media', media).then(
                            () => {
                                this.getAllNews();
                                this.getAllMedia(() => this.getAllNews());
                            });
                    });
            },
            editNews(news) {
                this.news = this.$helper.cpObj(news);
                this.editMode = true;
                this.news.fileName = news.path.split('/')[news.path.split('/').length - 1];

            },
        },
        mounted() {
            // console.log(window.innerWidth)
            if (window.innerWidth < this.img.width + 80) {
                this.img.width = window.innerWidth - 80
                this.img.height = (window.innerWidth - 80) * .75
            }
            // console.log(window.innerWidth)
        }
    };
</script>
